export const desktopMediaQuery = () =>
  window.matchMedia('only screen and (min-width: 1024px)');
export const isDesktop = () => desktopMediaQuery().matches;
export const touchMediaQuery = () => window.matchMedia('(pointer: coarse)');
export const isTouchDevice = () => touchMediaQuery().matches;

export default {
  desktopMediaQuery,
  isDesktop,
  touchMediaQuery,
  isTouchDevice,
};
